class ScrollToSection extends HTMLElement {
  constructor() {
    super()
    this.targetString = this.getAttribute('target') ?? 'next'
  }

  connectedCallback() {
    this.addEventListener('click', this.scrollToSection.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.scrollToSection.bind(this))
  }

  get sections() {
    return [...document.querySelectorAll('main section, main .shopify-section')]
  }

  get section() {
    return this.closest('section, .shopify-section')
  }

  get currentIndex() {
    return this.sections.findIndex((section) => section.id === this.section.id)
  }

  get target() {
    if (/^\d+$/.test(this.targetString)) {
      return this.sections[Number(this.targetString) - 1]
    }

    if (this.targetString === 'next') {
      return this.sections[this.currentIndex + 1]
    } else if (
      this.targetString === 'prev' ||
      this.targetString === 'previous'
    ) {
      return this.sections[this.currentIndex - 1]
    }

    return document.querySelector(this.targetString)
  }

  scrollToSection() {
    this.target?.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('scroll-to-section')) {
  customElements.define('scroll-to-section', ScrollToSection)
}
